module.exports = __webpack_public_path__ + "static/media/599.5e5f99c9.svg";